// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { environment } from '@environments/environment';

// Define dataLayer and the gtag function.
window.dataLayer = window.dataLayer || [];

function gtag() {
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

window.gtag = gtag;

window.dataLayer.push({
  siteName: environment.project,
  siteEnvironment: environment.envDomain === 'development' ? 'development' : 'production',
  isNativeApp: window.navigator.userAgent.includes('NetatmoApp'),
});

// Load the Google Tag Manager script.
(function (w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  const f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    dl = l != 'dataLayer' ? `&l=${l}` : '';
  j.async = true;
  j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
  f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', 'GTM-K3NSQW7');
